import {
  MdDashboard,
  MdBookmark,
  MdArticle,
  MdQrCode,
  MdPerson,
  MdBusiness,
  MdLibraryBooks,
  MdSchool,
} from 'react-icons/md';
import { FaChalkboard, FaChalkboardTeacher, FaWallet } from 'react-icons/fa';
import {
  FiBarChart2,
  FiCreditCard,
  FiCpu,
  FiCheckSquare,
  FiServer,
  FiWifi,
  FiClock,
  FiTrendingUp,
  FiTarget,
  FiUsers,
  FiDownload,
  FiTag,
  FiInbox,
  FiPercent,
  FiBriefcase,
} from 'react-icons/fi';
import { HiIdentification, HiOfficeBuilding } from 'react-icons/hi';

// Menu items for superadmin
export const MENU_ITEMS = [
  {
    groupTitle: 'Home',
    children: [
      {
        title: 'Dashboard',
        icon: MdDashboard,
        to: '/home',
      },
      {
        title: 'Business Dashboard',
        icon: FiBarChart2,
        to: '/dashboard/business',
      },
      {
        title: 'Freemium Analytics',
        icon: FiTrendingUp,
        to: '/freemium-analytics',
      },
      {
        title: 'Pendaftaran Sekolah',
        icon: MdSchool,
        to: '/school-registration',
      },
      {
        title: 'Gamification',
        icon: FiTarget,
        to: '/gamification',
      },
      {
        title: 'Teacher Gamification',
        icon: FiTarget,
        to: '/teacher-gamification',
      },
    ],
  },
  {
    groupTitle: 'School',
    children: [
      {
        title: 'List',
        icon: MdBookmark,
        to: '/school/register',
      },
      // {
      //   title: 'Tagihan',
      //   icon: FaWallet,
      //   to: '/school/billing',
      // },
      {
        title: 'Admin',
        icon: MdBookmark,
        to: '/school/admin',
      },
      {
        title: 'Siswa',
        icon: MdPerson,
        to: '/school/student',
      },
      {
        title: 'Guru',
        icon: FaChalkboardTeacher,
        to: '/school/teacher',
      },
      {
        title: 'Download Pas Foto',
        icon: FiDownload,
        to: '/school/pas-photo-download',
      },
      {
        title: 'Absensi',
        icon: FiCheckSquare,
        to: '/school/attendance',
      },
      {
        title: 'Mading',
        icon: FaChalkboard,
        to: '/school/bulletin-board',
      },
      {
        title: 'Artikel',
        icon: MdArticle,
        to: '/school/article',
      },
      {
        title: 'Seminar',
        icon: FaChalkboardTeacher,
        to: '/school/course',
      },
    ],
  },
  {
    groupTitle: 'KantinPay',
    children: [
      {
        title: 'QR Code Management',
        icon: MdQrCode,
        to: '/kantinpay/qr-management',
      },
      {
        title: 'Card Management',
        icon: FiCreditCard,
        to: '/kantinpay/cards',
      },
    ],
  },
  {
    groupTitle: 'Keuangan',
    children: [
      {
        title: 'Pencairan',
        icon: FaWallet,
        to: '/pencairan',
      },
    ],
  },
  {
    // Langganan SIS (S2a). Tanpa lencana hitungan antrean: MENU_ITEMS disajikan
    // ke SETIAP peran kecuali kepala_yayasan, dan permintaan antrean dari
    // laci navigasi akan dijawab 401 untuk admin/pic — interceptor
    // lib/client/handler.js lalu menghapus sesi mereka.
    groupTitle: 'Langganan',
    children: [
      { title: 'Preaccount', icon: FiInbox, to: '/preaccounts', requiredRole: 'superadmin' },
      {
        title: 'Katalog Harga',
        icon: FiTag,
        to: '/pricing/catalog',
      },
      {
        title: 'Perlu ditinjau',
        icon: FiInbox,
        to: '/pricing/review',
      },
      {
        title: 'Biaya Layanan UnggulPay',
        icon: FiPercent,
        to: '/unggulpay-fee',
      },
      {
        title: 'UnggulPay Enterprise',
        icon: FiBriefcase,
        to: '/unggulpay-enterprise',
      },
    ],
  },
  {
    groupTitle: 'Attendance',
    children: [
      {
        title: 'RFID Cards',
        icon: HiIdentification,
        to: '/rfid-cards',
      },
      {
        title: 'Device Management',
        icon: FiCpu,
        to: '/devices',
      },
      {
        title: 'Kiosk Management',
        icon: FiServer,
        to: '/kiosks',
      },
      {
        title: 'RFID Readers',
        icon: FiCpu,
        to: '/rfid-devices',
      },
      {
        title: 'Tailscale Monitoring',
        icon: FiWifi,
        to: '/tailscale',
      },
    ],
  },
  {
    groupTitle: 'Yayasan',
    children: [
      {
        title: 'Manajemen Yayasan',
        icon: HiOfficeBuilding,
        to: '/yayasan',
      },
    ],
  },
  {
    groupTitle: 'Undangan Orang Tua',
    children: [
      {
        title: 'Direktori Orang Tua',
        icon: MdPerson,
        to: '/parents',
      },
      {
        title: 'Daftar Undangan',
        icon: FiUsers,
        to: '/parent-invitations',
      },
      {
        title: 'Verifikasi Nomor',
        icon: FiCheckSquare,
        to: '/verifikasi-nomor',
      },
    ],
  },
  {
    groupTitle: 'Perpustakaan Digital',
    children: [
      {
        title: 'Semua Buku',
        icon: MdLibraryBooks,
        to: '/digital-library',
      },
      {
        title: 'Pending Approval',
        icon: FiClock,
        to: '/digital-library/pending',
      },
    ],
  },
];

// Menu items for kepala_yayasan (view-only)
export const KEPALA_YAYASAN_MENU_ITEMS = [
  {
    groupTitle: 'Dashboard',
    children: [
      {
        title: 'Dashboard Yayasan',
        icon: MdDashboard,
        to: '/yayasan-dashboard',
      },
    ],
  },
];
